module.exports = __webpack_public_path__ + "img/chengjiasi.bf878234.png";